<template>
    <div>
        <div class="tab-content search-fields-container" id="myTabContent">
            <div class="tab-pane fade show active" id="flight" role="tabpanel" aria-labelledby="flight-tab">
                <div class="section-tab section-tab-2 mb-2 pb-2 d-flex border-bottom border-green">
                    <p class="text-dark font-weight-bold mr-4">{{ lang('search_and_book') }}</p>
                    <ul class="nav nav-tabs" id="myTab3" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link" id="one-way-tab" v-bind:class="{ active: this.tripType === 'one_way' }" @click="setTripType('one_way')">
                                {{ lang('one_way') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="round-trip-tab" v-bind:class="{ active: this.tripType === 'return' }" @click="setTripType('return')">
                                {{ lang('return') }}
                            </a>
                        </li>
                    </ul>
                </div><!-- end section-tab -->
                <div class="tab-content" id="myTabContent3">
                    <div class="tab-pane fade show active" id="one-way" role="tabpanel" aria-labelledby="one-way-tab">
                        <div class="contact-form-action">
                            <form method="POST" :action="prop_page_ferry_times" class="row align-items-center" ref="search_form">
                                <input type="hidden" name="_token" :value="csrf">
                                <input type="hidden" name="trip_type" :value="this.tripType">
                                <div class="col-lg-6 pr-0">
                                    <div class="input-box">
                                        <label class="label-text">{{ lang('from') }}</label>
                                        <div class="form-group">
                                            <div id="autocomplete" class="autocomplete">
                                                <span class="la la-map-marker form-icon"></span>
                                                <input class="form-control autocomplete-input"
                                                       type="text" :placeholder="lang('country_or_port')"
                                                       v-model="search.from.text" name="from-name" autocomplete="off"
                                                       v-bind:class="{ 'is-invalid': search.from.validationText !== null }"
                                                       @keyup="startSearchFrom($event)"
                                                >
                                                <div class="invalid-feedback">
                                                    {{ search.from.validationText }}
                                                </div>
                                                <input type="hidden" name="from_id" :value="search.from.id">
                                                <input type="hidden" name="from_location_type" :value="search.from.location_type">
                                                <div  class="autocomplete-result-list" v-if="this.searchFromData.length !== 0">
                                                    <div class="result" v-for="(data_obj, data_index) in this.searchFromData" @click="setSearchFrom(data_obj)">
                                                        {{ data_obj.name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div><!-- end col-lg-3 -->
                                <div class="col-lg-6">
                                    <div class="input-box">
                                        <label class="label-text">{{ lang('to') }}</label>
                                        <div class="form-group">
                                            <div id="autocomplete" class="autocomplete">
                                                <span class="la la-map-marker form-icon"></span>
                                                <input class="form-control autocomplete-input"
                                                       type="text" :placeholder="lang('country_or_port')"
                                                       v-model="search.to.text" name="to-name" autocomplete="off"
                                                       v-bind:class="{ 'is-invalid': search.to.validationText !== null }"
                                                       @focus="startSearchTo($event)"
                                                       @keyup="searchFilter($event)"
                                                >
                                                <div class="invalid-feedback">
                                                    {{ search.to.validationText }}
                                                </div>
                                                <input type="hidden" name="to_id" :value="search.to.id">
                                                <input type="hidden" name="to_location_type" :value="search.to.location_type">
                                                <div  class="autocomplete-result-list" v-if="this.searchToDataFiltered.length !== 0">
                                                    <div class="result" v-for="(data_obj, data_index) in this.searchToDataFiltered" @click="setSearchTo(data_obj)">
                                                        {{ data_obj.name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div><!-- end col-lg-3 -->
                                <div class="pr-0" v-bind:class="[ (this.tripType === 'return') ? 'col-lg-2' : 'col-lg-3' ]">
                                    <div class="input-box">
                                        <label class="label-text">{{ lang('departing') }}</label>
                                        <div class="form-group">
                                            <span class="la la-calendar form-icon"></span>
                                            <input class="date-range form-control date-range-picker-single" type="text" name="date_from" :value="currentDate" readonly>
                                        </div>
                                    </div>
                                </div>
                                <div class="pr-0" v-bind:class="[ (this.tripType === 'return') ? 'col-lg-2' : 'd-none' ]">
                                    <div class="input-box">
                                        <label class="label-text">{{ lang('returning') }}</label>
                                        <div class="form-group">
                                            <span class="la la-calendar form-icon"></span>
                                            <input class="date-range form-control date-range-picker-single" type="text" name="date_to" :value="currentDateAddDay" readonly>
                                        </div>
                                    </div>
                                </div>
                                <div class="pr-0" v-bind:class="[ (this.tripType === 'return') ? 'col-lg-2' : 'col-lg-3' ]">
                                    <div class="input-box">
                                        <label class="label-text">{{ lang('drivers') }}</label>
                                        <div class="form-group select-contain w-auto">
                                            <select class="select-contain-select" name="number_of_drivers">
                                                <option value="1" selected>1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                            </select>
                                        </div>
                                    </div>
                                </div><!-- end col-lg-3 -->
                                <div class="col-lg-3 pr-0">
                                    <div class="input-box">
                                        <label class="label-text">{{ lang('vehicle') }}</label>
                                        <div class="form-group select-contain w-auto">
                                            <select class="select-contain-select" name="vehicle">
                                                <optgroup :label="lang(vehicle.name)" v-for="(vehicle, data_index) in this.prop_vehicle_type">
                                                    <option v-if="vehicle.vehicle_lengths.length !== 0" :value="vehicle.id +'-'+ vehicle_length.id" v-for="(vehicle_length, data_index) in vehicle.vehicle_lengths">
                                                        {{ lang(vehicle.name) }} {{ lang('up_to') }} {{ vehicle_length.max }} {{ lang('meters') }}
                                                    </option>
                                                    <option v-if="vehicle.vehicle_lengths.length === 0" :value="vehicle.id">
                                                        {{ lang(vehicle.name) }}
                                                    </option>
                                                </optgroup>
                                            </select>
                                        </div>
                                    </div>
                                </div><!-- end col-lg-3 -->
                                <div class="col-lg-3">
                                    <button type="button" class="theme-btn w-100 text-center margin-top-20px" @click="formSubmit()">{{ lang('search_now') }} </button>
                                </div>
                            </form>
                        </div>
                    </div><!-- end tab-pane -->
                </div>
            </div><!-- end tab-pane -->
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                currentDate: moment().format('DD/MM/YYYY'),
                currentDateAddDay: moment().add(1 , 'days').format('DD/MM/YYYY'),
                tripType: 'one_way',
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                search:{
                    from:{
                        text: '',
                        location_type: null,
                        id: null,
                        validationText: null
                    },
                    to:{
                        text: '',
                        location_type: null,
                        id: null,
                        validationText: null
                    }
                },
                searchFromData: [],
                searchToData: [],
                searchToDataFiltered: [],
                typingTimeout: null,
                //lang: null
            };
        },

        props: {
            prop_page_ferry_times: {
                required: true,
                type: String
            },
            prop_page_home_search_city_or_port_ajax: {
                required: true,
                type: String
            },
            prop_page_home_search_route_ajax: {
                required: true,
                type: String
            },
            prop_vehicle_type: {
                required: true,
                type: Array
            },
            prop_lang: {
                required: true,
                type: Object
            },
        },
        mounted() {

        },

        methods: {
            setTripType(type){
                this.tripType = type;
            },

            startSearchFrom(event){
                let _self = this;
                clearTimeout(this.typingTimeout);

                this.typingTimeout = setTimeout(function () {
                    _self.searchFromFetch(event);
                }, 1000);
            },

            formSubmit(){
                let errorText = 'The given data is invalid!';

                this.resetValidationErrorText();

                if (this.search.from.location_type !== null && this.search.from.id !== null && this.search.to.location_type !== null && this.search.to.id){
                    this.$refs.search_form.submit()
                } else {
                    if(this.search.from.id === null || this.search.from.location_type === null){
                        this.search.from.validationText = errorText;
                    }
                    if(this.search.to.id === null || this.search.to.location_type === null){
                        this.search.to.validationText = errorText;
                    }
                }
            },

            resetValidationErrorText(){
                this.search.from.validationText = null;
                this.search.to.validationText = null;
            },

            searchFromFetch(event){
                let _self = this;
                let searchText = event.target.value;
                let page_url = this.prop_page_home_search_city_or_port_ajax.replace('param_city_or_port_name', searchText);

                this.resetValidationErrorText();

                if (searchText.length < 3) {
                    _self.searchFromData = [];
                    return;
                }

                axios.get(page_url, {
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        'Accept': 'application/json'
                    }
                }).then(response => {
                    _self.searchFromData = response.data.values;
                }).catch(error => {
                    if (error.response.status === 422) {
                        if(error.response.data.errors.hasOwnProperty('city_or_port')){
                            _self.search.from.validationText = error.response.data.errors.city_or_port[0]
                        }
                        _self.searchFromData = [];
                    }
                }).finally(() => {

                });
            },

            startSearchTo(){
                let _self = this;

                let page_url =this.prop_page_home_search_route_ajax
                    .replace('param_id', _self.search.from.id)
                    .replace('param_location_type' +
                        '', _self.search.from.location_type);

                axios.get(page_url, {
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        'Accept': 'application/json'
                    }
                }).then(response => {
                    _self.searchToData = response.data.values;
                    _self.searchToDataFiltered = _self.searchToData;
                }).catch(error => {

                }).finally(() => {

                });
            },

            searchFilter(event){
                let text = event.target.value;
                this.searchToDataFiltered = this.searchToData.filter(c => c.name.toLowerCase().indexOf(text) > -1);

                if(this.searchToDataFiltered[0] !== undefined){
                    this.search.to.location_type = this.searchToDataFiltered[0].location_type;
                    this.search.to.id = this.searchToDataFiltered[0].id;
                }
            },

            setSearchFrom(obj){
                this.search.from.text = obj.name;
                this.search.from.location_type = obj.location_type;
                this.search.from.id = obj.id;

                this.searchFromDataSetEmpty();
            },

            setSearchTo(obj, setEmptyData = true){
                this.search.to.text = obj.name;
                this.search.to.location_type = obj.location_type;
                this.search.to.id = obj.id;

                if(setEmptyData){
                    this.searchToDataSetEmpty();
                }
            },

            searchFromDataSetEmpty(){
                this.searchFromData = [];
            },

            searchToDataSetEmpty(){
                this.searchToData = [];
                this.searchToDataFiltered = [];
            },
            lang(key){
                if (this.prop_lang.hasOwnProperty(key)){
                    return this.prop_lang[key];
                } else {
                    return 'invalid_key: ' + key;
                }
            }

        }
    }
</script>
